module.exports = __webpack_public_path__ + "static/meditators-mobile-beb7bd58eb8367b80ceaa557b27e554f.jpg";